// Global
import { jsx as _jsx } from "react/jsx-runtime";
// Local
import LocationsBlockClient from './LocationsBlockClient';
/**
 * Server entry point (App Router). Mirrors the project pattern used by
 * `ContextualNav` / `ArticleListing` / `PopularArticles`: this file stays a
 * Server Component so the catch-all route can stream it without a client
 * boundary, and all interactive logic (router, state, postcode lookup) lives
 * in the dedicated `LocationsBlock.client.tsx`.
 *
 * Note: do not add runtime values to this module that are consumed by the
 * client file — importing them back across the `'use client'` boundary
 * creates a circular module graph that App Router's static analyzer cannot
 * resolve (the helper would appear "not exported" at runtime).
 */ export const Default = (props)=>/*#__PURE__*/ _jsx(LocationsBlockClient, {
        ...props
    });
